<template>
    <div class="ClusterDetails">
        <table v-loading="is_cluster_list_loading">
            <thead>
                <tr>
                    <th>CLUSTER NAME</th>
                    <th>&nbsp;</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(cluster, cluster_index) in cluster_list" :key="cluster_index">
                    <td>
                        <div class="mt-4 title cursor-pointer" @click="goToEditCluserPage(cluster.id)">{{ cluster.name }}</div>
                        <div>
                            <div v-for="(outlet, outlet_index) in cluster.outlets" :key="outlet_index" class="mt-4">
                                <span class="capitalize">- {{ outlet.name }}</span>
                            </div>
                        </div>
                    </td>

                    <td style="width: 10%;">
                        <div style="display: flex; justify-content: center;">
                            <img src="../../../assets/images/edit.png" style="margin-right: 10px;" @click="goToEditCluserPage(cluster.id)"/>
                            <img src="../../../assets/images/delete-icon.png" @click="deleteCluster(cluster)"/>
                        </div>
                    </td>
                </tr>
            </tbody>
        </table>

        <div v-if="!cluster_list.length" class="no-data-notification">
            No data available
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import labourPlanningService from '../../../services/labourPalnningService';

export default {
    name: 'ClusterDetails',
    
    data() {
        return {
            is_cluster_list_loading: false,
            cluster_list: [],
            outlets_list: []
        }
    },

    mounted(){
        this.getCombinedData();
    },

    methods: {
        getAllClusters(){
            return labourPlanningService.getAllClusters()
				.then(response => {
                    return response;
				})
				.catch(err => {
                    console.log(err);
				});
        },

        // api to get all outlets list
		getOutletsList() {
			return labourPlanningService.getAllStoreDataCluster()
            .then(response => {
                return response;
            })
            .catch(err => {
                console.log(err);
            });
        },

        getCombinedData(){
            this.outlets_list = [];
            this.cluster_list = [];

            this.is_cluster_list_loading = true;    //enabled loader

            axios.all([this.getAllClusters(), this.getOutletsList()])
            .then(axios.spread((allClustersRes, allOutletsRes) => {

                let allClusterList = JSON.parse(allClustersRes.data);
                let allOutletsList = JSON.parse(allOutletsRes.data);

                if(allOutletsList.length){
                    this.outlets_list = allOutletsList.filter(e => {
						if (e.type == "store") {
							return e;
						}
					});
                }

                if(allClusterList.length){
                    let cluster_list = allClusterList;

                    for(let i=0; i<cluster_list.length; i++){
                        for(let j=0; j<cluster_list[i].outlets.length; j++){
                            let filterd_outlet = this.outlets_list.filter(e =>{
                                return e.id == cluster_list[i].outlets[j];
                            })[0];

                            if(filterd_outlet){
                                let obj = {
                                    outlet_id: filterd_outlet.id,
                                    name: filterd_outlet.name 
                                }
                                cluster_list[i].outlets[j] = obj;
                            }
                        }
                    }

                    this.cluster_list = cluster_list;
                }

                this.is_cluster_list_loading = false;  //disabled loader
            })).catch(errors => {
                this.is_cluster_list_loading = false;  //disabled loader
            })
            .finally(() => {
                this.is_cluster_list_loading = false;  //disabled loader
            });
        },

        deleteCluster(cluster){
            if(cluster.id){
                this.is_cluster_list_loading = true;    //enabled loader

                labourPlanningService.deleteCluster(cluster.id)
                .then(async function(response) {
                    if(response.status == 200){
                        // called get all cluster api to get updated cluster list
                        let res = await this.getAllClusters();

                        if(res.status == 200){
                            this.cluster_list = [];

                            let cluster_list = JSON.parse(res.data);

                            for(let i=0; i<cluster_list.length; i++){
                                for(let j=0; j<cluster_list[i].outlets.length; j++){
                                    let filterd_outlet = this.outlets_list.filter(e =>{
                                        return e.id == cluster_list[i].outlets[j];
                                    })[0];
        
                                    if(filterd_outlet){
                                        let obj = {
                                            outlet_id: filterd_outlet.id,
                                            name: filterd_outlet.name 
                                        }
                                        cluster_list[i].outlets[j] = obj;
                                    }
                                }
                            }
                            this.cluster_list = cluster_list;

                            this.$notify.success({
                                title: "Success",
                                message: "Cluster deleted successfully..!"
                            });
                        }
                    }else{
                        this.$notify.error({
                            title: "Error",
                            message: "Something went wrong..!"
                        });
                    }

                    this.is_cluster_list_loading = false;    //disabled loader
                }.bind(this))
                .catch(err => {
                    console.log(err);
                });
            }
        },

        goToEditCluserPage(cluster_id){
            this.$router.push({path: '/create-cluster', query: { id: cluster_id }})
        }
    }
}
</script>

<style lang="scss" scoped>
.ClusterDetails{
    table {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        // border: 1px solid #bebebe;
    }

    thead th {
        height: 40px;
        color: #707070;
        background-color: #f2f2f2!important;
        text-transform: uppercase;
    }

    tbody td, thead th {
        // height: 50px;
        padding: 5px 40px;
        font-size: 13px;
    }

    td{
        text-align: center;
        img{
            width: 18px;
            cursor: pointer;
        }
    }
    
    td:first-child, th:first-child {
        text-align: left;
    }

    .title{
        color: #7ea9f8;
        font-size: 0.9rem;
        font-weight: bold;
    }
    
    .no-data-notification{
        text-align: center;
        font-size: 14px;
        font-weight: 600;
        color: #e29d5a;
        padding: 15px;
    }
}
</style>